module.exports = __webpack_public_path__ + "prod/1.42.2/media/medical.f3b0f86a.mp4";